import styled from 'styled-components';
import { rgba } from 'polished';
import { BLACK } from '@/constants/colors';

const BrowseByServiceSection = styled.section`
  .browse-by-service,
  &.browse-by-service {
    .service-card {
      background: ${rgba(BLACK, 0.8)};
    }
  }
`;

export default BrowseByServiceSection;
